export default __webpack_public_path__ + "static/media/Standard.dd511661.png";